module.exports = __webpack_public_path__ + "static/media/far_off_01.efea1f63.png";